/**
 * Helper to build up enum-like objects where keys are equal to values.
 *
 * Example:
 *
 * ```ts
 * const Action = mirror(['LOGIN', 'LOGOUT']);
 * console.log(Action); // { LOGIN: 'LOGIN', LOGOUT: 'LOGOUT' };
 * ```
 */
export function mirror<T extends string>(keys: T[]): Record<T, T> {
  return keys.reduce(
    (all, key) => ({ ...all, [key]: key }),
    {} as Record<T, T>
  );
}
